import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { CartProvider } from "./contexts/CartContext";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import DashboardPage from "./pages/DashboardPage";
import TablePage from "./pages/TablePage";
import PaymentSuccess from "./pages/PaymentSuccess";
import AdminPage from "./pages/AdminPage";
import ReservationPage from "./pages/ReservationPage";
import ServerPage from "./pages/ServerPage";
import KitchenPage from "./pages/KitchenPage";
import SuperAdminPage from "./pages/SuperAdminPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import OnboardingPage from "./pages/OnboardingPage";
import SettingsPage from "./pages/SettingsPage";
import StockPage from "./pages/StockPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import LegalPage from "./pages/LegalPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ReferralPage from "./pages/ReferralPage";
import CaissePage from "./pages/CaissePage";
import ManagerPage from "./pages/ManagerPage";
import AssistantChat from "./components/AssistantChat";

function AppContent() {
  const { token } = useAuth();
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/table/:tableId" element={<TablePage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/reservation" element={<ReservationPage />} />
          <Route path="/legal/:pageType" element={<LegalPage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* App (after login) */}
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/super-admin" element={<SuperAdminPage />} />
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/stock" element={<StockPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/referral" element={<ReferralPage />} />
          <Route path="/server" element={<ServerPage />} />
          <Route path="/kitchen" element={<KitchenPage />} />
          <Route path="/caisse" element={<CaissePage />} />
          <Route path="/manager" element={<ManagerPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/tables" element={<Navigate to="/admin" replace />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      {token && <AssistantChat />}
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <CartProvider>
          <AppContent />
        </CartProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
